module.exports = __webpack_public_path__ + "img/9.4cb5fcb1.jpg";